import { Image } from '@/components/client';

import { BENEFIT_IMAGES, TYPOGRAPHY_IMAGES } from '../../constants';

export const TaxDeductionCard = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center gap-10">
        <Image
          src={BENEFIT_IMAGES.panpare.url}
          alt={BENEFIT_IMAGES.panpare.alt}
          width={BENEFIT_IMAGES.panpare.width}
          height={BENEFIT_IMAGES.panpare.height}
          quality={75}
          loading="lazy"
          className="object-contain"
        />
      </div>
      <div className="flex w-full flex-col items-center gap-4 text-center">
        <p className="font-600 text-Gray-600 typo-body4">10만원 기부하면,</p>
        <Image
          src={TYPOGRAPHY_IMAGES.taxDeduction.url}
          alt={TYPOGRAPHY_IMAGES.taxDeduction.alt}
          width={TYPOGRAPHY_IMAGES.taxDeduction.width}
          height={TYPOGRAPHY_IMAGES.taxDeduction.height}
          loading="lazy"
          className="object-contain"
        />
      </div>
    </>
  );
};

export const GiftCard = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center gap-10">
        <Image
          src={BENEFIT_IMAGES.giftBox.url}
          alt={BENEFIT_IMAGES.giftBox.alt}
          width={BENEFIT_IMAGES.giftBox.width}
          height={BENEFIT_IMAGES.giftBox.height}
          quality={75}
          loading="lazy"
          className="object-contain"
        />
      </div>
      <div className="flex w-full flex-col items-center gap-4 text-center">
        <p className="font-600 text-Gray-600 typo-body4">3만원 상당</p>
        <Image
          src={TYPOGRAPHY_IMAGES.premiumGift.url}
          alt={TYPOGRAPHY_IMAGES.premiumGift.alt}
          width={TYPOGRAPHY_IMAGES.premiumGift.width}
          height={TYPOGRAPHY_IMAGES.premiumGift.height}
          loading="lazy"
          className="object-contain"
        />
      </div>
    </>
  );
};
